/*
 *
 * Copyright (C) 2022 NetBase Solutions, Inc.
 * 3960 Freedom Circle Suite 201 Santa Clara, CA 95054
 * All rights reserved.
 */

import messageUtil from 'utils/messageUtil'
import AnalysisType, { AnalysisTypeStrings } from 'enums/AnalysisType'
import ViewOption, { InsightViewOptionStrings } from 'enums/InsightViewOption'
import InsightType, { InsightTypeStrings } from 'enums/InsightType'

/**
 * Get the display text from a word cloud item name.
 */
export const getDisplayText = (
  name: string,
  viewOption: InsightViewOptionStrings,
  emojiNameToDisplayMap: Record<string, string>
) => {
  switch (viewOption) {
    case ViewOption.EMOJIS_EMOJI:
    case ViewOption.EMOJIS_EMOTION:
    case ViewOption.EMOJIS_GROUP:
      return emojiNameToDisplayMap[name]
    case ViewOption.DETECT_OBJECTS:
      return messageUtil.photoConceptObjectLabel(name)
    case ViewOption.DETECT_SCENES:
      return messageUtil.photoConceptScenesLabel(name)
    case ViewOption.DETECT_EMOTIONS:
      return messageUtil.photoConceptEmotionsLabel(name)
    default:
      return name
  }
}

export const getColor = (analysisType: AnalysisTypeStrings, insightType?: InsightTypeStrings) => {
  if (
    analysisType !== AnalysisType.SW_LIKES_AND_DISLIKES &&
    analysisType !== AnalysisType.AM_LIKES_AND_DISLIKES
  ) {
    return undefined
  }
  switch (insightType) {
    case InsightType.LIKES:
    case InsightType.POSITIVE_BEHAVIORS:
    case InsightType.POSITIVE_EMOTIONS:
    case InsightType.POSITIVE_EMOTIONS_OR_BEHAVIORS:
      return 'sentiment.positive'
    case InsightType.DISLIKES:
    case InsightType.NEGATIVE_BEHAVIORS:
    case InsightType.NEGATIVE_EMOTIONS:
    case InsightType.NEGATIVE_EMOTIONS_OR_BEHAVIORS:
      return 'sentiment.negative'
    default:
      return undefined
  }
}
